//Package imports
import React from "react";
import { Typography, TextField } from "@mui/material";
import { useController } from "react-hook-form";

const CustomTextField = ({
  control,
  name,
  label,
  placeholder,
  size,
  value,
  rules,
  onChange,
  rows,
  type,
  multiline,
  header,
  required,
  disabled,
  inputProps,
  backgroundColor,
  borderRadius,
  maxWidth,
  event,
  InputProps,
  onKeyPress,
  onKeyDown,
  marginBottom,
  marginTop,
  maxHeight,
  isSignPage,
  classStyle,
  error,
  helperText,
  width,
}) => {

  // entire error handling is happening through use controllers
  const { field, fieldState, formState } = useController({
    control,
    name,
    rules,
    defaultValue: value || "",
  });
  

  // const { error } = fieldState || rules;

  // handle change data is used for on Change functionality
  const handleChangeData = (e) => {
    field.onChange(e);
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === 'Space') {
      e.preventDefault(); // Prevent the default Enter key behavior (form submission)
    }
  };

  const customStyles = {
    // Add your custom styles here
    // For example, to change the font size of the select option:
    '& .MuiSelect-select': {
      // fontSize: '14px',
      fontWeight: 'normal'
    },
  };


  return (
    <>
    <div class="d-flex flex-column">
      <div class="d-flex justify-content-between">
          <label class=" fw-normal ">
            {header}
          </label>
          
      </div>
      <TextField
        {...field}
        type={type}
        label={label}
        variant="outlined"
        fullWidth
        value={value}
        multiline={multiline}
        disabled={disabled}
        size={size}
        onKeyDown={ isSignPage ? null : handleKeyPress}
        rows={rows}
        placeholder={placeholder}
        error={!!error}
        helperText={helperText}
        className={classStyle}
        onChange={handleChangeData}
        inputProps={inputProps}
        backgroundColor={backgroundColor}
        borderRadius={borderRadius}
        maxWidth={maxWidth}
        InputProps={{
          ...InputProps,
           
        }}
      />
     
      <errors class="">
            <Typography variant="p5" mb={2}>
              {error?.message}
            </Typography> 
        </errors>
       
        </div>
    </>
  );
};

export default CustomTextField;
